import Dropdown from 'react-bootstrap/Dropdown';

interface SortOption<TKey extends string> {
  key: TKey;
  value: string;
}

interface SortByDropdownProps<TKey extends string> {
  options: readonly SortOption<TKey>[];
  onSelect: (key: TKey) => void;
  selected?: TKey;
  testId?: string;
}

const SortByDropdown = <TKey extends string>({
  options,
  onSelect,
  selected,
  testId = 'sort-dropdown',
}: SortByDropdownProps<TKey>) => {
  const selectedOption = options.find((option) => option.key === selected);

  return (
    <Dropdown data-testid={testId} onSelect={onSelect as (eventKey: string | null) => void}>
      <Dropdown.Toggle className="btn-light--outline" variant="light">
        <span className="dropdown--hint">Sort By </span>
        {selectedOption?.value}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item
            active={option.key === selected}
            data-value={option.key}
            eventKey={option.key}
            key={option.key}
          >
            {option.value}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SortByDropdown;
